import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {userRegister} from "../../services/userRegister";

class ModalKeyword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            keyword: "",
            email: "",
            isLoading: false,
            inhouse: false,
            error: false,
            success: false
        };
    };

    componentWillMount() {
        this._updateUser();
        this.setState({keyword: this.props.initKeyword});
    }

    _updateUser(){
        let user = userRegister.get();
        try{
            if(user.email){
                this.setState({
                    email: user.email,
                    inhouse: user.inhouse
                });
            }
        }catch (e) {}
    }

    _close(value){
        this.props.setKeyword(value);
    }

    _set(){
        if(this._emailValidation(this.state.email)){
            this.setState({isLoading: true, error: false});
            let data = {email: this.state.email, name: this.state.keyword, subject: "industry request", message: salesChannelRegister.get('market')};
            dataRegister.industryRequest(salesChannelRegister.get('market'), salesChannelRegister.get('name'), data).then((response) => {
                this._close(true);
            }, (error) => {
                this._close(true);
                this.setState({isLoading: false});
            });
        }else{
            this.setState({error: true});
        }
    }

    _emailValidation(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    _terms() {
        window.open('https://legal.' + dataRegister.domain + "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/terms/" + salesChannelRegister.get('name'), '_blank');
    }

    _renderText(item) {
        return langRegister.get("modal-keyword", item);
    }

    render() {
        return (
              <div className={Styles.overlay}>
                  <div className={Styles.overlayModal}>
                      <div className={Styles.overlayModalInner}>
                          <img onClick={() => this._close(false)}
                               className={Styles.overlayCloseButton}
                               src={require("../../assets/images/close_icon.svg")}/>
                          <div>
                              <div className={Styles.overlayModalText}>
                                  {this._renderText("item_1")}
                              </div>
                              <div className={Styles.overlayModalText}>
                                  <span className={Styles.overlayModalTextBold}>{this.state.keyword}</span>, <span className={Styles.overlayModalTitle}>{this._renderText("item_2")}</span>
                              </div>
                              <div className={Styles.overlayModalInputContainer}>
                                  <input disabled={this.state.inhouse} className={
                                      cx(Styles.overlayModalInputContainerInput,
                                          {
                                              [Styles.overlayModalInputContainerInputError]: this.state.error && !this._emailValidation(this.state.email)
                                          })
                                  }  value={this.state.email} onChange={(event) => this.setState({email: event.target.value})} placeholder={this._renderText("item_4")}/>
                                  <div className={
                                      cx(Styles.overlayModalInputContainerInputLine,
                                          {
                                              [Styles.overlayModalInputContainerInputLineError]: this.state.error && !this._emailValidation(this.state.email)
                                          })
                                  }/>
                              </div>
                              <div className={Styles.overlayModalTerms}>
                                  {this._renderText("item_5")}&nbsp;<span onClick={() => this._terms()} className={Styles.overlayModalTermsLink}>{this._renderText("item_6")}</span>
                              </div>
                          </div>
                      </div>
                      <div className={Styles.overlayModalButtons}>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => {this._set()}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                  {
                                      this.state.isLoading &&
                                      <BeatLoader size={9} color={'#ffffff'} loading={true}/>
                                  }
                                  {
                                      !this.state.isLoading &&
                                      this._renderText("item_3")
                                  }
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        );
    }
}

export default ModalKeyword;


// WEBPACK FOOTER //
// ./src/components/modal-keyword/component.js